// Models
import { Filter } from "../client/filter/Filter";
import { TaskStatus } from "../service/planner/enumerations/IPlannerEnumerations";
/**
 * Filter options for the Status filter menu.
 * Includes all real TaskStatus values plus a derived "late" option for client-side late task filtering.
 */ export const StatusFilterOption = {
    NotStarted: TaskStatus.NotStarted,
    InProgress: TaskStatus.InProgress,
    Late: "late",
    Completed: TaskStatus.Completed,
    Blocked: TaskStatus.Blocked
};
// Re-export dynamic filter constants (separate file to avoid circular dependency with Filter.ts)
export { DynamicFilterField, NonPersistedFilterFields } from "./DynamicFilterConstants";
/**
 * Filter field identifier for the keyword filter.
 */ export const KeywordFilterField = "displayName";
/**
 * Task Filter types
 */ export var FilterTypes = /*#__PURE__*/ function(FilterTypes) {
    FilterTypes["StartDateTime"] = "StartDateTime";
    FilterTypes["DueDateTime"] = "DueDateTime";
    FilterTypes["FinishDateTime"] = "FinishDateTime";
    FilterTypes["Priority"] = "Priority";
    FilterTypes["Status"] = "Status";
    FilterTypes["AppliedCategoryIds"] = "AppliedCategoryIds";
    FilterTypes["BucketId"] = "BucketId";
    FilterTypes["UserAssignments"] = "UserAssignments";
    FilterTypes["PersonalView"] = "PersonalView";
    FilterTypes["GoalIds"] = "GoalIds";
    return FilterTypes;
}({});
/** Prefix for custom field filter field IDs to avoid collision with built-in FilterFields values */ export const CUSTOM_FIELD_FILTER_PREFIX = "cfFilter_";
/** Prefix of a date filter value that encodes an inclusive custom range, e.g. "customRange:2026-01-01:2026-01-31". */ export const CustomDateRangeFilterPrefix = "customRange:";
/**
 * Stable filter value for the "No value" option in custom field filter submenus (Flag,
 * SingleChoiceText). Used both as the menu item value/key for checked-state tracking and as the
 * persisted filter value, matching tasks that have no value set for the custom field.
 */ export const NoCustomFieldValueFilterKey = "__cfNoValue__";
/**
 * Maps the Task FilterTypes to the filter field key in ITask
 */ export const FilterFields = {
    StartDateTime: "startDateTime",
    DueDateTime: "dueDateTime",
    FinishDateTime: "finishDateTime",
    Priority: "priority",
    Status: "status",
    AppliedCategoryIds: "planView.appliedCategoryIds",
    BucketId: "bucketId",
    UserAssignments: "userAssignments",
    PersonalView: "personalView.isOnMyDay",
    GoalIds: "goalIds"
};
/**
 * Task filter options for Basic Plan
 */ export const BasicPlanFilterOptions = [
    "StartDateTime",
    "DueDateTime",
    "FinishDateTime",
    "Priority",
    "Status",
    "BucketId",
    "AppliedCategoryIds",
    "UserAssignments",
    "GoalIds"
];
/**
 * Task filter options for My Tasks
 */ export const MyTasksFilterOptions = [
    "StartDateTime",
    "DueDateTime",
    "Priority",
    "Status"
];
/**
 * Task filter options for a todo based plan.
 * Todo plans do not support finish dates (PermissionsStore returns canUpdateFinishDateTime: false
 * for ContainerType.ToDo), so the FinishDate filter is intentionally omitted.
 */ export const TodoPlanFilterOptions = [
    "Priority",
    "Status",
    "PersonalView"
];
/**
 * Default Filters for My Tasks, Basic Plans, Lists
 * By default, the views will not show completed tasks to reduce the amount of data shown upfront
 */ export const DefaultFilter = new Filter("status", [
    TaskStatus.NotStarted,
    TaskStatus.InProgress
]);
